export default "__VITE_ASSET__53427615__"